module.exports = __webpack_public_path__ + "static/media/workshop.2050f86c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/workshop.jpg
// module id = 208
// module chunks = 0